export const SIMILARITY_SEARCH_HOW_IT_WORKS_VIDEO_URL =
  'https://www.loom.com/share/e5aae84cf3a6426389c08a0bb20c21a9';
export const COMPANY_LOOKALIKE_SEARCH_HOW_IT_WORKS_VIDEO_URL =
  'https://www.loom.com/share/e5aae84cf3a6426389c08a0bb20c21a9';
export const AI_CONTACT_PROFILE_ANALYTICS_HOW_IT_WORKS_VIDEO_URL =
  'https://www.loom.com/share/62369bb78bd44c6ebefa598b9cbb043e';
export const ADVANCE_COMPANY_SEARCH_HOW_IT_WORKS_VIDEO_URL =
  'https://www.loom.com/share/8ffb8e51a7bf497c8065371b63adc96a';
export const ADVANCE_PEOPLE_SEARCH_HOW_IT_WORKS_VIDEO_URL =
  'https://www.loom.com/share/e906a8a599ab4a2f8686f38aeb74c88b';
export const ENRICHMENT_HOW_IT_WORKS_VIDEO_URL =
  'https://www.loom.com/share/6841d06c5f644b3ea93ee1ff80218627';
export const PROFILE_INSIGHT_WHAT_IS_VIDEO_URL =
  'https://www.loom.com/share/672f9aea24884639a3432a576e3d9e19';
export const HOW_TO_US_CITIES_FILTER_BULK_DIALOG_VIDEO_URL =
  'https://www.loom.com/share/f9214ff52dc3413e8ea18ef776eba130';
export const PLATFORM_WALKTHROUGH_VIDEO_URL =
  'https://www.loom.com/share/127a5409047d4dd59df9443e8fd70574';
export const DEVELOPER_API_HOW_IT_WORKS =
  'https://www.loom.com/share/3f98607c3b744f15908c0c10075dcf7c';
export const DATA_VISUALISATION_HOW_IT_WORKS =
  'https://www.loom.com/share/864c69eaba464b8cb96c70f9854db418';
// TODO: replace with the real Search Payload tutorial video URL.
export const HOW_TO_USE_SEARCH_PAYLOAD_VIDEO_URL = '';
